import Flickity from "flickity";
import "flickity/css/flickity.css";

class HeroSlider {
	constructor() {

		var elems = document.querySelectorAll('.mk-hero-slider .mk-slides');

		if (elems){
			elems.forEach((elem) => {

				var flkty = new Flickity( elem, {
					// options
					// cellAlign: 'left',
					cellSelector: '.dgs-hero',
					contain: true,
					adaptiveHeight: false,
					autoPlay: 15000,
					wrapAround: true,
					prevNextButtons: true,
					pageDots: false,
				});
		
				const slideCounter = elem.parentNode.querySelector('.mk-slide-counter');
		
				const counters = slideCounter.querySelectorAll('span');
		
				counters[1].innerHTML = flkty.cells.length;
				
				const progressbar = slideCounter.querySelector('.progressbar');
				const pointer = progressbar.querySelector('.pointer');
				var pw = Math.floor(progressbar.getBoundingClientRect().width / flkty.cells.length)
				pointer.style.width = pw + 'px';
				
				flkty.on( 'change', function( index ) {
					// update counter
					counters[0].innerHTML = index+1;
					// move pointer
					pointer.style.transform = `translate(${pw*index}px, 0)`;
				});
			});
		}


	}
}
export default HeroSlider



/*

import Glide from "@glidejs/glide"

class HeroSlider {
  constructor() {
    const allSlideshows = document.querySelectorAll(".mk-hero-slider")
    allSlideshows.forEach(function (currentSlideshow) {
      // count how many slides there are
      const dotCount = currentSlideshow.querySelectorAll(".dgs-hero").length

      // Generate the HTML for the navigation dots
      let dotHTML = ""
      for (let i = 0; i < dotCount; i++) {
        dotHTML += `<button class="slider__bullet glide__bullet" data-glide-dir="=${i}"></button>`
      }

			console.log(currentSlideshow);

      // Add the dots HTML to the DOM
			const bullets = currentSlideshow.querySelector(".glide__bullets");
			if (bullets){
				bullets.insertAdjacentHTML("beforeend", dotHTML);
			}

      // Actually initialize the glide / slider script
      var glide = new Glide(currentSlideshow, {
        type: "carousel",
        perView: 1,
        autoplay: 30000
      })

      glide.mount()
    })
  }
}
export default HeroSlider

*/
